// The platform's tick for something done: the one a met item of the readiness list wears (ReadinessList.tsx), in its
// fixed green, never the theme's accent, which is black by default. The game shows it on a reached goal (23.2) and on
// an answered statement under a bar (97), a UI concept the platform already uses. It is
// decoration: whoever shows it also says in words what it means.

export function DoneTick() {
  return (
    <span aria-hidden="true" className="font-semibold text-emerald-700">
      ✓
    </span>
  );
}
